import React from 'react';

var Separador = function Separador() {
  return React.createElement("div", {
    className: "separadorBarraHerramientas"
  });
};

export default Separador;